/// <reference path="../../../WebUI/typings/tsd.d.ts" />

export { signOut } from "./Controllers/SignOut";
import {DevPortalAppBase} from '../DevPortalAppBase';
import { AccountSettingsController } from "./Controllers/AccountSettingsController";
import {BotsController} from "./Controllers/BotsController";
import {BotEditController} from "./Controllers/BotEditController";
import {RedirectController} from "../Controllers/RedirectController";
import {BotController} from "./Controllers/BotController";
import {ControllerBase} from "./Controllers/ControllerBase";
import {FlightController} from "../Controllers/FlightController";
import {BotCreateSwitchController} from "./Controllers/BotCreateSwitchController";
import {AzurePortalPageController} from "./Controllers/AzurePortalPageController";
import { WebChatController } from "./Controllers/WebChatController";
import {BotOpenComposerController} from "./Controllers/BotOpenComposerController";
import { HeaderKind } from "./Utility/HeaderKind";
import { SupportedFeatureUtility } from "./Utility/SupportedFeatureUtility";
import Rest = require("../Generated/RestClient");
import { Environment } from "../../../Intercom.ReactUI/Utils/Environment";

class BotCreateNewController extends BotEditController {
    constructor(app: DevPortalApp) {
        super(app);
        this.headerKind = HeaderKind.Jumbo;
    }
}

export class DevPortalApp extends DevPortalAppBase {
    public checkAnnouncementsInterval: number;

    constructor() {
        super();

        const router = this.getRouter();
        router.addRoute("/bots/provision", BotCreateSwitchController);
        // redirect bot creation page to provision page
        router.addRoute("/bots/new", BotCreateSwitchController);
        router.addRoute("/bots/newbot", BotCreateSwitchController);
        router.addRoute("/redirect", RedirectController);
        router.addRoute("/flight", FlightController);
        router.addRoute("/bots/code", BotController);
        router.addRoute("/bots/codesetup", BotController);
        router.addRoute("/bots/openComposer", BotOpenComposerController);
        router.addRoute("/code", AzurePortalPageController);
        router.addRoute("/codev2", AzurePortalPageController);

        // BotPage.BotTabs
        router.addRoute("/bots/build", BotController);
        router.addRoute("/bots/channels", BotController);
        router.addRoute("/bots/analytics", BotController);
        router.addRoute("/bots/settings", BotController);

        // The User account settings controller
        if (SupportedFeatureUtility.isSupported(Rest.DevPortalFeatureFlags.SupportNonAzureUsers)) {
            router.addRoute("/account", AccountSettingsController);
        }

        // WebChat without headers/etc. Used in Azure blade.
        router.addRoute("/bots/webchat", BotController);

        // WebChat used in Ibiza Azure blade - delete the one above once the blade is updated.
        router.addRoute("/az/webchat", WebChatController);

        router.setCustomResolver((path, params) => {
            const lowerPath = path ? path.toLowerCase().trim() : null;
            if (lowerPath === '/bots') {
                if (params['id']) {
                    return { controllerClass: BotController };
                } else {
                    return { controllerClass: BotsController };
                }
            }
            return null;
        });

        router.setPageNotFoundController(PageNotFoundController);

        this.announcements = {
            isFeatureFlighted: this.isFeatureFlighted('Announcements'),
            all: [],
            shownIdCount: {},
            addShown: () => {
                this.announcements.all.forEach(a => this.announcements.shownIdCount[a.Id]++);
                this.updateAnnouncements();
            }
        };

        this.load();

        if (this.announcements.isFeatureFlighted && !Environment.isInBotFrameworkAzureExtension) {
            this.fetchAnnouncements();
            this.checkAnnouncementsInterval = setInterval(() => this.fetchAnnouncements(), 120000);
        }
    }

    private fetchAnnouncements() {
        Rest.AnnouncementsClient.announcements().done(all => {
            this.announcements.all = all;
            all.forEach(a => this.announcements.shownIdCount[a.Id] = this.announcements.shownIdCount[a.Id] || 0);
            this.updateAnnouncements();
        });
    }

    public updateAnnouncements() {
        const router = this.getRouter();
        const currentController = router.getCurrentController() as ControllerBase;
        if (currentController && currentController.setAnnouncementState) {
            currentController.setAnnouncementState(this.announcements);
        }
    }

}

class PageNotFoundController extends SimpleMvc.Controller {
    public load(params: SimpleMvc.QueryParams): void {
        $.get("/404.html", (data) => {
            SimpleMvc.App.getInstance().getAppBody().innerHTML = data;
        });
    }
}



// WEBPACK FOOTER //
// ./Client/v4/DevPortalApp.ts